module.exports = __webpack_public_path__ + "img/166.58533f48.jpg";